<!-- Holiday hours notice -->
@if (html) {
  <div class="holiday-notice" [innerHtml]="html"></div>
}
